export const CLEAR_DONORS = 'CLEAR_DONORS/DONOR/@WISELY/WEB';
export const CLEAR_DONOR_UPDATE_ERRORS = 'CLEAR_DONOR_UPDATE_ERRORS/DONOR/@WISELY/WEB';
export const GET_DONOR = 'GET_DONOR/DONOR/@WISELY/WEB';
export const GET_DONORS = 'GET_DONORS/DONOR/@WISELY/WEB';
export const FETCH_DONOR_FAILED = 'FETCH_DONOR_FAILED/DONOR/@WISELY/WEB';
export const FETCH_DONORS_FAILED = 'FETCH_DONORS_FAILED/DONOR/@WISELY/WEB';
export const FETCH_DONOR_SUCCEEDED = 'FETCH_DONOR_SUCCEEDED/DONOR/@WISELY/WEB';
export const FETCH_DONORS_SUCCEEDED = 'FETCH_DONORS_SUCCEEDED/DONOR/@WISELY/WEB';
export const UPDATE_DONOR = 'UPDATE_DONOR/DONOR/@WISELY/WEB';
export const UPDATE_DONOR_FAILED = 'UPDATE_DONOR_FAILED/DONOR/@WISELY/WEB';
export const UPDATE_DONOR_SUCCEEDED = 'UPDATE_DONOR_SUCCEEDED/DONOR/@WISELY/WEB';

export const CREATE_NEW_ASSIGNMENT_REQUESTED = 'CREATE_NEW_ASSIGNMENT_REQUESTED/DONOR/@WISELY/WEB';
export const CREATE_NEW_ASSIGNMENT_SUCCEEDED = 'CREATE_NEW_ASSIGNMENT_SUCCEEDED/DONOR/@WISELY/WEB';
export const CREATE_NEW_ASSIGNMENT_FAILED = 'CREATE_NEW_ASSIGNMENT_FAILED/DONOR/@WISELY/WEB';

export const UPDATE_ASSIGNMENT_REQUESTED = 'UPDATE_ASSIGNMENT_REQUESTED/DONOR/@WISELY/WEB';
export const UPDATE_ASSIGNMENT_SUCCEEDED = 'UPDATE_ASSIGNMENT_SUCCEEDED/DONOR/@WISELY/WEB';
export const UPDATE_ASSIGNMENT_FAILED = 'UPDATE_ASSIGNMENT_FAILED/DONOR/@WISELY/WEB';

export const ASSIGNMENT_TYPES = 'assignment_types';
export const CONSTITUENT_TYPES = 'constituent_types';
export const NEWLY_ASSIGNED = 'newly_assigned';
export const TOP_PROSPECT = 'top_prospect';
export const MONTHLY_DONOR = 'monthly_donor';
export const AT_RISK = 'at_risk';
export const UPDATE_FILTER = 'UPDATE_FILTER/DONOR/@WISELY/WEB';

export const SET_SORT_BY = 'SET_SORT_BY/DONOR/@WISELY/WEB';



// WEBPACK FOOTER //
// ./src/redux/donors/donor.constant.js